export const API_URL = {articles: 'https://bg.polet.vdnh.ru/api/pages'};